import __request__ from "routing/request";
export function list(fleetId, page = 1, per_page = 50, query, sort = "name", order = "asc", requestOptions) {
  return __request__("GET", `/collectors/fleets/${fleetId}/sources`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(fleetId, JSONbody, requestOptions) {
  return __request__("POST", `/collectors/fleets/${fleetId}/sources`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(fleetId, sourceId, JSONbody, requestOptions) {
  return __request__("PUT", `/collectors/fleets/${fleetId}/sources/${sourceId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(fleetId, sourceId, requestOptions) {
  return __request__("GET", `/collectors/fleets/${fleetId}/sources/${sourceId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(fleetId, sourceId, requestOptions) {
  return __request__("DELETE", `/collectors/fleets/${fleetId}/sources/${sourceId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
